import { Component, OnInit } from "@angular/core";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from "@angular/router";
import { CommonModule } from "@angular/common";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { OvenChartModalComponent } from "../chart-modal/oven-chart-modal.component";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { MatIconButton } from "@angular/material/button";
@Component({
  selector: "app-additional-params",
  templateUrl: "./additional-params.component.html",
  styleUrls: ["./additional-params.component.scss"],
  standalone: true,
  imports: [CommonModule, OvenChartModalComponent,MatIconButton],
})
export class AdditionalParamsComponent implements OnInit {
  public baseOvenUrl = BaseUrlConstantsService.OVEN_BASE_URL;
  public company_name: string;
  public today: Date;
  public breadcrumbsArray: any = [
    {
      page_ref: "oven-dashboard",
      page_title: "Device Room",
    },
    {
      page_ref: "#",
      page_title: "Oven Dashboard",
    },
  ];
  openModal = false;
  params: { subsystemId: string; clientId: string } = {
    subsystemId: "",
    clientId: "",
  };
  oven_params_list: any = [];
  curr_parameter = "";

  constructor(
    private router: Router,
    private srv: BackendApiService,
    private act_route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.company_name = localStorage.getItem("company_name");
    this.utcTime();

    this.act_route.queryParams.subscribe((res: any) => {
      this.params = res;
      this.fetchAllOvenParams();
    });
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
    };
    this.router.navigate([name], navigationExtras);
  }
    goToBackToDashboard() {
    const navigationExtras = {
      skipLocationChange: true,
    };
    this.router.navigate(["oven-dashboard"], navigationExtras);
  }
   
  fetchAllOvenParams() {
    try {
      this.srv
        .getDataV2(
          `${this.baseOvenUrl}api/v1/oven-assets/all-params/${this.params.subsystemId}/${this.params.clientId}`
          // `http://localhost:3024/api/v1/oven-assets/all-params/${this.params.subsystemId}/${this.params.clientId}`
        )
        .then((res: any) => {
          const { code, status, data } = res;
          if (code == 200 && status == "success") {
            const { dbResponse } = data;
            this.oven_params_list = dbResponse;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {}
  }

  getChartParameters(parameter) {
    this.openModal = true;
    this.curr_parameter = parameter;
    document.body.style.overflow = "hidden";
  }
  closeModal() {
    this.openModal = false;
    this.curr_parameter = null;
    document.body.style.overflow = "auto";
  }
  ngOnDestroy() {
    // Clean up - re-enable scrolling
    document.body.style.overflow = "auto";
  }
}
